import type { BIGeneralBetratioParams, BIGeneralBetratio } from "@/api/interfaces/bigeneral";
import { BiGeneralApiHttpClient } from "./bigeneral-http-client";

export async function getBIGeneralBetratio(params: { id: string | number }): Promise<BIGeneralBetratio> {
    const queryParams: BIGeneralBetratioParams = {
        r: "sb",
        id: String(params.id),
    };
    const response = await BiGeneralApiHttpClient.get("/BETRATIO", { params: queryParams });
    return response.data;
}
